import React, { useRef } from 'react';

const ContactUs = () => {
     const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = formRef.current;
    const name = form.name.value;
    const email = form.email.value;
    const subject = form.subject.value;
    const message = form.message.value;

    const mailtoLink = `mailto:jivanjyotitrust123@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\n${message}`
    )}`;

    window.location.href = mailtoLink;
  };
  return (
    <div className="bg-gray-50 min-h-screen flex items-center justify-center px-4 py-16" id="contact">
      <div className="max-w-xl w-full bg-white rounded-3xl shadow-xl p-10">
        <div className="mb-10 text-center">
          <h2 className="text-3xl font-bold text-indigo-700">Contact Us</h2>
          <p className="mt-2 text-gray-600">
            We'd love to hear from you. Whether you want to support, volunteer, or just say hello — reach out.
          </p>
        </div>

        <form ref={formRef} onSubmit={handleSubmit} className="space-y-6">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              className="w-full bg-gray-100 p-4 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              className="w-full bg-gray-100 p-4 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div>
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              className="w-full bg-gray-100 p-4 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div>
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              required
              className="w-full bg-gray-100 p-4 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div>
            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              required
              className="w-full bg-gray-100 p-4 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-xl transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
